import { Form, DatePicker } from 'antd'
import { useEffect, useState } from 'react'
import { Language } from '../../../config/Language'

interface IProps {
    id?: string
    label: string
    name: string
    type?: any
    className?: string
    required?: boolean
    requiredMessage?: string
    placeholder?: string
    showTooltips?: boolean
    value?: any
    disabled?: boolean
    onChange?: any
    tooltipTitle?: string
}

export const CustomDatePicker = ({ ...props }: IProps) => {
    const { getTranslation } = Language()
    const {
        id,
        label,
        name,
        className,
        required = false,
        requiredMessage = getTranslation('required'),
        value,
        type,
    } = props

    const [selectedValue, setSelectedValue] = useState<any>(null)

    useEffect(() => {
        if (selectedValue !== value) {
            setSelectedValue(value)
        }
        return () => {}
    }, [value])

    return (
        <Form.Item
            id={id}
            name={name}
            className={className}
            valuePropName='option'
            label={label}
            rules={[
                {
                    type: type,
                    required: required,
                    message: requiredMessage,
                },
            ]}>
            <DatePicker value={selectedValue} />
        </Form.Item>
    )
}
